import { useTranslation } from 'react-i18next'
import {
  SearchAutocomplete,
  SearchAutocompleteOption,
} from '@/components/inputs'
import { ReimbursementTypes } from '@/types'

type ReimbursementTypeMultiSelectProps = {
  value?: string
  onChange: (value: string | undefined) => void
}

export const ReimbursementTypeMultiSelect = ({
  value,
  onChange,
}: ReimbursementTypeMultiSelectProps): JSX.Element => {
  const { t } = useTranslation('expensesDeclaration')

  const options = Object.keys(ReimbursementTypes).map((key) => {
    const type = ReimbursementTypes[
      key as keyof typeof ReimbursementTypes
    ] as string

    return {
      label: t(`reimbursementTypes.${type}`),
      value: type,
    } as SearchAutocompleteOption
  })

  return (
    <SearchAutocomplete
      value={value}
      onChange={onChange}
      options={options}
      placeholder={t('placeholders.reimbursementType')}
      sort={false}
      fieldSx={{ width: 280 }}
    />
  )
}
